import { createSlice } from '@reduxjs/toolkit'


const initialState = {
   tiles: true,
   search: false,
   status: 'ok',
   error: null
}

const appSlice = createSlice({
   name: 'app',
   initialState,
   reducers: {
      setTiles(state) {
         state.tiles = true
      },
      unsetTiles(state) {
         state.tiles = false
      },
      openSearch(state) {
         state.search = true
      },
      closeSearch(state) {
         state.search = false
      },
      setError(state, action) {
         state.status = 'error'
         state.error = action.payload
      },
      clearError(state) {
         state.status = 'ok'
         state.error = null
      }
   }
})

export const app = appSlice.reducer
export const { setTiles, unsetTiles, openSearch, closeSearch, setError, clearError } = appSlice.actions
